export enum EntityStoreKey {
  tellentTwoFactorAuthentication = 'tellentTwoFactorAuthentication',
  signInConsent = 'signInConsent',
}

export interface TellentTwoFactorAuthenticationSetup {
  appEnabled: boolean;
  canEnable2fa: true;
  id: number;
  otpSecret: string;
  smsEnabled: boolean;
  phone: string;
}

export interface SignInConsent {
  accessRevokedAt: string | null;
  createdAt: string;
  expiryDate: string;
  id: number;
}
